// extracted by mini-css-extract-plugin
module.exports = {"disabled":"WithdrawColumns_disabled__hq1Es"};